import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const Footer = () => {
  return (
    <footer>
      <StaticImage
        className="logo-image"
        layout="constrained"
        formats={['auto', 'webp', 'avif']}
        src="../../images/logo.png"
        alt="Logo"
        placeholder="blurred"
      />
    </footer>
  );
};

export default Footer;
